/* eslint-disable */
import React, { useEffect, useState } from "react";

import Form from "components/Form";
import {
  ROLES_URL,
  URLS,
  NEW_USER_URL,
  STORAGE_CONSTANT,
} from "configs/constants";
import { fetchDataFromApi, getAssignedModule } from "utils";
import eightAxios from "configs/axiosConfig";
import { useNotifyContext } from "components/Notify";
import { useHistory, useParams } from "react-router-dom";
import { Grid, TextField } from "@material-ui/core";
import PropTypes from "prop-types";
import Modal from "components/Modal";
import CheckIcon from "@material-ui/icons/Check";
import BlockIcon from "@material-ui/icons/Block";

const initialValues = {
  employee_id: "",
};

const urls = {
  proxyURL: "new-user/pending-users/",
  exportURL: "new-user/pending-users/export/",
  approveURL: "new-user/{id}/approve-pending-user/",
  declineURL: "new-user/{id}/decline-pending-user/",
};

const RemarkBody = ({ setRemarks, errorMessage, type }) => {
  const remarksHandler = (event) => {
    event.preventDefault();
    setRemarks(event.target.value);
  };
  return (
    <Grid container direction="column" spacing={2} style={{ padding: "10px" }}>
      <Grid item>
        {type === "approve" ? (
          <p>Are you sure you want to approve this user?</p>
        ) : (
          <TextField
            variant="outlined"
            name="description"
            fullWidth
            multiline
            rows={3}
            inputProps={{ maxLength: 50 }}
            onChange={remarksHandler}
          />
        )}
        <Grid container justify="center">
          {errorMessage ? (
            <p style={{ textAlign: "center", color: "red" }}>{errorMessage}</p>
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  );
};
RemarkBody.propTypes = {
  setRemarks: PropTypes.func,
  errorMessage: PropTypes.string,
  type: PropTypes.string,
};

const PendingUserForm = () => {
  const params = useParams();
  const setNotify = useNotifyContext();
  const history = useHistory();
  const [roles, setRoles] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [remarks, setRemarks] = useState("");
  const [modalFields, setModalFields] = useState({
    id: null,
    title: "Add Remarks",
    isOpen: false,
    body: null,
    confirmButtonLabel: "Approve User",
    onConfirm: null,
    type: "approve",
    resetModalBodyState: () => setErrorMessage(""),
  });

  useEffect(() => {
    fetchDataFromApi(ROLES_URL, setRoles, true);
  }, []);

  useEffect(() => {
    const workerRole = roles.find((role) => role.name === "Worker");
    if (roles.includes(workerRole)) {
      setRoles(roles.filter((item) => item.name !== "Worker"));
    }
  }, [roles]);

  useEffect(() => {
    setModalFields({
      ...modalFields,
      body: (
        <RemarkBody
          errorMessage={errorMessage}
          setRemarks={setRemarks}
          type={modalFields.type}
        />
      ),
      onConfirm: () => {
        let s = ""
        if (modalFields.type === "approve"){
          s = "Approval";
        }else{
          s = "Decline";
        }
        eightAxios
          .post(
            modalFields.type === "approve"
              ? urls.approveURL.replace("{id}", params.id)
              : urls.declineURL.replace("{id}", modalFields.id),
            {
              remarks: remarks,
            }
          )
          .then((response) => {
            setModalFields({ ...modalFields, isOpen: false });
            setNotify({
              isOpen: true,
              message: response.data.message,
              type: "success",
            });
            history.push(URLS.PENDING_APPROVAL_LIST);
          })
          .catch((error) => {
            if (error.response) {
              let errMsg = "";
              for (let key in error.response.data) {
                errMsg += error.response.data[key] + "\n";
              }
              setErrorMessage(errMsg);
              setNotify({
                isOpen: true,
                message:
                  "User " + s + " failed. Please try again.",
                type: "error",
              });
            } else {
              setErrorMessage(error.message);
              setNotify({
                isOpen: true,
                message:
                  "User " + s + " failed. Please try again.",
                type: "error",
              });
            }
          })
      },
    });
  }, [modalFields.id, errorMessage, remarks, modalFields.type]);

  const approveUser = () => {
    setModalFields({
      ...modalFields,
      id: params.id,
      isOpen: true,
      type: "approve",
      confirmButtonLabel: "Approve User",
      title: "User Approval",
    });
  };

  const declineUser = () => {
    setModalFields({
      ...modalFields,
      id: params.id,
      isOpen: true,
      type: "decline",
      confirmButtonLabel: "Reject User",
      title: "Add Remarks",
    });
  };

  const formFields = [
    { type: "title", title: "Personal Details" },
    {
      type: "renderonly",
      name: "employee_id",
      key: "employee_id",
      label: "Employee ID",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "name",
      key: "name",
      label: "Name",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "nationality",
      key: "nationality",
      label: "Nationality",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "worker_type",
      key: "worker_type",
      label: "Worker Type",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "id_type_name",
      key: "id_type_name",
      label: "ID Type",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "id_number",
      key: "id_number",
      label: "ID Number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "mobile_number",
      key: "mobile_number",
      label: "Mobile Number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "role_name",
      key: "role_name",
      label: "Role",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "status",
      key: "status",
      label: "Status",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    { type: "title", title: "Employment Details" },
    {
      type: "renderonly",
      name: "worker_group_name",
      key: "worker_group_name",
      label: "Worker Group",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "company_name",
      key: "company_name",
      label: "Company",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "zone_name",
      key: "zone_name",
      label: "Zone",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "region_name",
      key: "region_name",
      label: "Region",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "estate_name",
      key: "estate_name",
      label: "Estate",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "division_name",
      key: "division_name",
      label: "Division",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "block_name",
      key: "block_name",
      label: "Block",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    { type: "title", title: "Audit Details" },
    {
      type: "renderonly",
      name: "created_at_datetime",
      key: "created_at_datetime",
      label: "Created Date and Time",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "created_by",
      key: "created_by",
      label: "Created By",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    // FIXME: Uncomment to add allowables
    { type: "title", title: "Allowable Estate Details" },

    {
      type: "renderonly",
      name: "allowables.All_Estates",
      key: "allowables.All_Estates",
      valueType: "boolean",
      noValue: "No",
      yesValue: "Yes",
   
      label: "All Estates",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "allowables.Zones",
      key: "allowables.Zones",
      label: "Allowable Zone",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "allowables.Regions",
      key: "allowables.Regions",
      label: "Allowable Region",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "allowables.Estates",
      key: "allowables.Estates",
      label: "Allowable Estate",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
  ];

  const formButtons = [
    {
      label: "Approve",
      startIcon: <CheckIcon />,
      color: "primary",
      onClick: () => approveUser(),
    },
    {
      label: "Decline",
      startIcon: <BlockIcon />,
      onClick: () => declineUser(),
    },
    "cancel",
  ];

  let module = getAssignedModule(location.pathname);
  let actionPermission = false;
  if (!module || module === "") {
    actionPermission = true;
  } else {
    let updatedModules = JSON.parse(
      localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES)
    );
    if (updatedModules[module]) {
      let modulePermissions = updatedModules[module].map((perm) => {
        if (typeof perm === "string") {
          return perm.toLowerCase();
        }
        return perm;
      });
      if (modulePermissions.includes("change status")) {
        actionPermission = true;
      }
    }
  }

  return (
    <div>
      <Form
        initialValues={initialValues}
        submitUrl={NEW_USER_URL}
        listRoute={URLS.PENDING_APPROVAL_LIST}
        formFields={formFields}
        formButtons={actionPermission ? formButtons : ["cancel"]}
        formTitle="Pending User"
        noTypography
      />
      <Modal modalFields={modalFields} setModalFields={setModalFields} />
    </div>
  );
};

export default PendingUserForm;
